import { Injectable, computed } from '@angular/core';
import { UserStateService } from '../services/user-state.service';
import { ROLE_HIERARCHY } from '../../shared/models/role-hierarchy-model';

@Injectable({ providedIn: 'root' })
export class RolesService {
  constructor(private userState: UserStateService) {}

  /** The user's highest role, derived directly from UserStateService.
   * Falls back to 'free' if the accountStatus is not a recognized role tier
   * (e.g., 'new' — user has not yet chosen a plan; the onboarding guard prevents
   * access before this service's role check is relevant for such users).
   */
  public readonly highestRole = computed(() => {
    const status = this.userState.accountStatus();
    return ROLE_HIERARCHY.includes(status) ? status : 'free';
  });

  /** Returns true if user meets or exceeds the required tier */
  hasOrExceeds(required: string): boolean {
    const userRole = this.highestRole();
    if (!userRole) {
      return false;
    }

    const userRoleIndex = ROLE_HIERARCHY.indexOf(userRole);
    const requiredRoleIndex = ROLE_HIERARCHY.indexOf(required);

    if (userRoleIndex === -1 || requiredRoleIndex === -1) {
      return false;
    }

    return userRoleIndex >= requiredRoleIndex;
  }
}
